(function () {
  'use strict';

  var ATTRS = ['src', 'srcset', 'data-src', 'data-srcset'];
  var RESTORE_DELAYS = [0, 300, 1000, 2000];
  var observedImages = new WeakSet();
  var restoringImages = new WeakSet();

  function getDataRoot(el) {
    if (!el) return null;
    if (el.matches('.product-card__image[data-ev-grid-metafield="true"]')) {
      return el;
    }
    if (el.matches('.product-card__image-link[data-ev-grid-metafield="true"]')) {
      return (
        el.querySelector('.product-card__image[data-ev-grid-metafield="true"]') ||
        el
      );
    }
    return el.closest(
      '.product-card__image[data-ev-grid-metafield="true"], .product-card__image-link[data-ev-grid-metafield="true"]'
    );
  }

  function collectRoots() {
    var roots = [];
    var seen = new Set();

    document
      .querySelectorAll('.product-card__image[data-ev-grid-metafield="true"]')
      .forEach(function (el) {
        if (!seen.has(el)) {
          seen.add(el);
          roots.push(el);
        }
      });

    document
      .querySelectorAll('.product-card__image-link[data-ev-grid-metafield="true"]')
      .forEach(function (link) {
        var root =
          link.querySelector('.product-card__image[data-ev-grid-metafield="true"]') ||
          link;
        if (!seen.has(root)) {
          seen.add(root);
          roots.push(root);
        }
      });

    return roots;
  }

  function findVisibleImage(root) {
    return (
      root.querySelector('.product-card__img-visible') ||
      root.querySelector('.product-card__img.ev-grid-metafield-img')
    );
  }

  function findHiddenImage(root) {
    return root.querySelector('.product-card__img-hidden');
  }

  function normalizeUrl(url) {
    return (url || '').split('?')[0];
  }

  function urlsMatch(current, expected) {
    if (!expected) return true;
    if (!current) return false;
    return normalizeUrl(current) === normalizeUrl(expected);
  }

  function applyImage(img, src, srcset) {
    if (!img || !src) return;

    restoringImages.add(img);

    img.setAttribute('src', src);
    img.setAttribute('data-src', src);

    if (srcset) {
      img.setAttribute('srcset', srcset);
      img.setAttribute('data-srcset', srcset);
    }

    if (img.classList.contains('lazyload') && !img.classList.contains('lazyloaded')) {
      img.classList.add('lazyloaded');
      img.classList.remove('lazyload');
    }

    restoringImages.delete(img);
  }

  function srcsetsMatch(current, expected) {
    if (!expected) return true;
    if (!current) return false;
    return current.trim() === expected.trim();
  }

  function needsRestore(img, src, srcset) {
    if (!img || !src) return false;

    if (!urlsMatch(img.getAttribute('src'), src)) return true;
    if (!urlsMatch(img.getAttribute('data-src'), src)) return true;

    if (srcset) {
      if (!srcsetsMatch(img.getAttribute('srcset'), srcset)) return true;
      if (!srcsetsMatch(img.getAttribute('data-srcset'), srcset)) return true;
    }

    return false;
  }

  function restoreCard(root) {
    if (!root || root.getAttribute('data-ev-grid-metafield') !== 'true') return;

    var mainSrc = root.getAttribute('data-ev-main-src');
    var hoverSrc = root.getAttribute('data-ev-hover-src');
    var mainSrcset = root.getAttribute('data-ev-main-srcset');
    var hoverSrcset = root.getAttribute('data-ev-hover-srcset');

    var visible = findVisibleImage(root);
    var hidden = findHiddenImage(root);

    if (visible && needsRestore(visible, mainSrc, mainSrcset)) {
      applyImage(visible, mainSrc, mainSrcset);
    }

    if (hidden && hoverSrc && needsRestore(hidden, hoverSrc, hoverSrcset)) {
      applyImage(hidden, hoverSrc, hoverSrcset);
    }
  }

  function observeImage(img, root) {
    if (!img || observedImages.has(img)) return;
    observedImages.add(img);

    var observer = new MutationObserver(function (mutations) {
      if (restoringImages.has(img)) return;

      var shouldRestore = mutations.some(function (mutation) {
        return (
          mutation.type === 'attributes' &&
          ATTRS.indexOf(mutation.attributeName) !== -1
        );
      });

      if (shouldRestore) {
        restoreCard(root);
      }
    });

    observer.observe(img, {
      attributes: true,
      attributeFilter: ATTRS
    });
  }

  function bindCard(root) {
    restoreCard(root);

    var visible = findVisibleImage(root);
    var hidden = findHiddenImage(root);

    if (visible) observeImage(visible, root);
    if (hidden) observeImage(hidden, root);
  }

  function restoreAll() {
    collectRoots().forEach(bindCard);
  }

  function scheduleRestores() {
    RESTORE_DELAYS.forEach(function (delay) {
      window.setTimeout(restoreAll, delay);
    });
  }

  function init() {
    restoreAll();
    scheduleRestores();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.addEventListener('load', function () {
    restoreAll();
    scheduleRestores();
  });

  document.addEventListener('shopify:section:load', restoreAll);
})();
